import {
  IDataStringArray,
  IDataStringNumber,
  ICadastro,
  ILogin,
} from "../models";
import { api } from "../configs";

export const CriarUsuario = async (criacaoDados: ICadastro) => {
  return await api.post("/user/create", {
    name: criacaoDados.nome,
    email: criacaoDados.email,
    password: criacaoDados.senha,
  });
};

export const LogarUsuario = async (autenticacao: ILogin) => {
  try {
    const dados = await api.post("/user/auth", {
      email: autenticacao.email,
      password: autenticacao.senha,
    });
    return dados;
  } catch (err) {
    return err;
  }
};

export const MostrarTodosUsuarios = async () => {
  const retorno = await api
    .get("/users")
    .then((res) => {
      return res.data;
    })
    .catch(function (err) {
      console.log(err);
    });

  return retorno;
};

export const CarregarDadosUsuario = async (email: string) => {
  const dados = await api.get(`/user?email=${email}`).then((res) => {
    return res.data;
  });
  return dados;
};

export const RecuperarSenhaUsuario = async (email: string) => {
  try {
    const resp = await api.put("/user/recover", { email });
    return resp.data;
  } catch (err) {
    console.error(err);
  }
};

export const UpdateSenha = async (
  email: string,
  senha: string,
  novaSenha: string
) => {
  try {
    const resp = await api.put("/user/update/password", {
      email,
      oldPasswordB64: senha,
      newPasswordB64: novaSenha,
    });
    return resp.data;
  } catch (err) {
    console.error(err);
  }
};

export const UpdateExperiencia = (updateDados: IDataStringNumber) => {
  api.put("/user/update/experience", {
    email: updateDados.email,
    newValue: updateDados.novoValor,
  });
};

export const UpdateLevel = (updateDados: IDataStringNumber) => {
  api.put("/user/update/level", {
    email: updateDados.email,
    newValue: updateDados.novoValor,
  });
};

export const UpdateSistema = (updateDados: IDataStringArray) => {
  api.put(`/user/update/system`, {
    email: updateDados.email,
    newValue: updateDados.novoValor,
  });
};
